import React, { useState, useEffect } from 'react';
import { 
  Key,
  Video,
  ExternalLink,
  Copy,
  Book,
  Shield,
  BookMarked,
  Film,
  ChevronRight
} from 'lucide-react';
import { formatearFechaCompleta} from '../../utils/utils'; // Importamos desde el archivo utils.js
import { useConfiguracion } from '../../metodos/ConfiguracionContext';

const RecursosTutor = () => {
  const [reglamentos, setReglamentos] = useState([]);
  const [tutoriales, setTutoriales] = useState([]);
  const {
    configuracion,
    loadingconfiguracion,
    errorconfiguracion,
  } = useConfiguracion();
    
  //cargue de cosas
  useEffect(() => {
    // Simulando carga de datos
    const cargarDatos = () => {
      // Datos de reglamentos
      const reglamentosData = [
        { 
          nombreReglamento: 'Normatividad para tutores', 
          linkUrl: 'https://docs.google.com/document/d/1AEhWlRvZkNark91EmrzSGAaSVmT1fqoK/edit',
          descripcion: 'Guía completa de normatividad y reglas para tutores',
          icono: <Shield size={20} className="text-indigo-600" />
        },
        { 
          nombreReglamento: 'Pautas de trabajos y examenes', 
          linkUrl: 'https://docs.google.com/document/d/1hJEwVesKwYMRTkgm1FOBwCzuwUn9sp92/edit',
          descripcion: 'Lineamientos para la realización de trabajos académicos',
          icono: <BookMarked size={20} className="text-indigo-600" />
        },
        /*
        { 
          nombreReglamento: 'Guía de asesorías', 
          linkUrl: 'https://docs.google.com/document/d/1P8dp2cvV138wn5QMoAMAK_e6MbgWwjw0ER7au3oX0FM/edit',
          descripcion: 'Protocolo para realizar sesiones de asesoría efectivas',
          icono: <Lightbulb size={20} className="text-indigo-600" />
        },
        */
       /*
        { 
          nombreReglamento: 'Manual de elaboración de tesis', 
          linkUrl: 'https://docs.google.com/document/d/1D28w3avpgjajuPl5J-YnoHUgqq-N2rtyOJDp1Vn22yU/edit',
          descripcion: 'Metodología completa para el desarrollo de tesis',
          icono: <BookOpen size={20} className="text-indigo-600" />
        }
        */
      ];

      // Datos de tutoriales
      const tutorialesData = [
        { 
          titulo: 'Uso completo de la plataforma v1.1.95', 
          link: 'https://www.youtube.com/watch?v=vpKP9oaGY0g',
          descripcion: 'Tutorial sobre todas las funcionalidades de la plataforma',
          duracion: '06:37',
          icono: <Video size={20} className="text-red-600" />
        },
        { 
          titulo: 'Proceso de solicitud de pagos v1.1.74', 
          link: 'https://www.youtube.com/watch?v=9Bp3lh2fQto',
          descripcion: 'Guía paso a paso para solicitar pagos en el sistema',
          duracion: '05:25',
          icono: <Film size={20} className="text-red-600" />
        }
      ];

      setReglamentos(reglamentosData);
      setTutoriales(tutorialesData);
    };

    cargarDatos();
  }, []);
  
  // Función para copiar al portapapeles
  const copiarTexto = (texto) => {
    navigator.clipboard.writeText(texto);
    alert('Texto copiado al portapapeles');
  };

  // Función para abrir enlaces externos
  const abrirEnlace = (url) => {
    window.open(url, '_blank');
  };

  // Si está cargando, mostrar un indicador de carga
  if (loadingconfiguracion) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  // Si hay un error, mostrar mensaje de error
  if (errorconfiguracion) {
    return (
      <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
        <strong className="font-bold">Error: </strong>
        <span className="block sm:inline">
          {errorconfiguracion || "Ocurrió un error al cargar los datos"}
        </span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header principal */}
      <div className="bg-gradient-to-r from-indigo-600 to-blue-500 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold leading-7 text-white sm:text-3xl">
            Portal de Recursos
          </h1>
          <p className="mt-1 text-sm text-indigo-100">
            Guías, documentos y herramientas para tutores
          </p>
        </div>
      </div>
      
      {/* Contenido principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

        {/* Sección 1: Normatividad y Reglamentos */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <Book size={24} className="text-indigo-600 mr-2" />
            <h2 className="text-xl font-bold text-gray-800">Normatividad y Reglamentos</h2>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <ul className="divide-y divide-gray-100">
              {reglamentos.map((reglamento, index) => (
                <li key={index}>
                  <div className="px-6 py-4 flex items-start hover:bg-gray-50 transition-colors">
                    <div className="flex-shrink-0 mt-1">
                      {reglamento.icono}
                    </div>
                    <div className="ml-4 flex-1">
                      <h3 className="font-medium text-gray-900">{reglamento.nombreReglamento}</h3>
                      <p className="mt-1 text-sm text-gray-500">{reglamento.descripcion}</p>
                    </div>
                    <div className="ml-4 flex-shrink-0">
                      <button
                        onClick={() => abrirEnlace(reglamento.linkUrl)}
                        className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center"
                      >
                        Ver documento
                        <ExternalLink size={14} className="ml-1" />
                      </button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        
        {/* Sección 2: Cuentas Profesionales */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <Key size={24} className="text-emerald-600 mr-2" />
            <h2 className="text-xl font-bold text-gray-800">Cuentas Profesionales</h2>
          </div>
                  
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <ul className="divide-y divide-gray-100">
              
              {configuracion.cuentaProfesional && configuracion.cuentaProfesional.length > 0 ? (
                configuracion.cuentaProfesional.map((cuenta, index) => (
                  
                  <li key={cuenta.nombreCuenta || index} className="py-4 hover:bg-gray-50 transition-colors">
                    <div className="px-6 pb-3 flex items-center">
                      <div className="flex-shrink-0 p-1.5 px-3 bg-emerald-600 rounded-full text-white text-xs font-bold flex items-center justify-center">
                        
                        {cuenta.nombreCuenta.charAt(0).toUpperCase()}

                      </div>
                      <div className="ml-3">

                        <h3 className="font-medium text-gray-900">{cuenta.nombreCuenta}</h3>
                        
                      </div>
                    </div>
                    
                    <div className="mt-2 px-6">
                      <div className="flex items-center justify-between py-2">
                        <div className="text-sm text-gray-700">
                          <span className="font-medium">Link: </span>
                          <a 
                            href={cuenta.linkCuenta}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline"
                          >
                            {cuenta.linkCuenta}
                          </a>
                        </div>
                        <button
                          onClick={() => abrirEnlace(cuenta.linkCuenta)}
                          className="text-emerald-600 hover:text-emerald-800 p-1 rounded-full bg-emerald-50"
                        >
                          <ExternalLink size={14} />
                        </button>
                      </div>
                      
                      <div className="flex items-center justify-between border-t border-gray-100 py-2">
                        <div className="text-sm text-gray-700">
                          <span className="font-medium">Usuario: </span>
                          {cuenta.correo}
                        </div>
                        <button
                          onClick={() => copiarTexto(cuenta.correo)}
                          className="text-emerald-600 hover:text-emerald-800 p-1 rounded-full bg-emerald-50"
                        >
                          <Copy size={14} />
                        </button>
                      </div>
                      
                      <div className="flex items-center justify-between border-t border-gray-100 py-2">
                        <div className="text-sm text-gray-700">
                          <span className="font-medium">Contraseña: </span>
                          {cuenta.contrasena}
                        </div>
                        <button
                          onClick={() => copiarTexto(cuenta.contrasena)}
                          className="text-emerald-600 hover:text-emerald-800 p-1 rounded-full bg-emerald-50"
                        >
                          <Copy size={14} />
                        </button>
                      </div>
                      
                      <div className="border-t border-gray-100 pt-2 pb-1 flex flex-col sm:flex-row sm:justify-between">
                        <div className="text-xs text-gray-500 mb-1 sm:mb-0">
                          Actualizado: {formatearFechaCompleta(cuenta.fechaActualizacionCuenta)}
                        </div>
                        <div className="text-xs text-red-500">
                          ¿Problemas? Contáctanos al{' '}
                          <button 
                            onClick={() => abrirEnlace("https://wa.me/573161585420?text=Hola,%20tengo%20un%20problema%20con%20mi%20cuenta.")}
                            className="text-blue-600 font-medium hover:underline"
                          >
                            +57 316 158 5420
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              ) : (
                /* Mensaje a mostrar si el array está vacío */
                <li className="p-6 text-center text-gray-500">
                  No hay cuentas profesionales configuradas.
                </li>
              )}

            </ul>
          </div>

        </div>
        
        {/* Sección 3: Tutoriales en Video */}
        <div>
          <div className="flex items-center mb-4">
            <Video size={24} className="text-red-600 mr-2" />
            <h2 className="text-xl font-bold text-gray-800">Tutoriales en Video</h2>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <ul className="divide-y divide-gray-100">
              {tutoriales.map((tutorial, index) => (
                <li key={index}>
                  <div 
                    className="px-6 py-4 flex items-start hover:bg-gray-50 transition-colors cursor-pointer"
                    onClick={() => abrirEnlace(tutorial.link)}
                  >
                    <div className="flex-shrink-0 mt-1">
                      {tutorial.icono}
                    </div>
                    <div className="ml-4 flex-1">
                      <h3 className="font-medium text-gray-900">{tutorial.titulo}</h3>
                      <p className="mt-1 text-sm text-gray-500">{tutorial.descripcion}</p>
                      <span className="inline-block mt-2 text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">
                        {tutorial.duracion}
                      </span>
                    </div>
                    <div className="ml-4 flex-shrink-0">
                      <ChevronRight size={20} className="text-red-500" />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </div>
  );
};

export default RecursosTutor;